import { ClientSafeReportViewV1Schema, InternalReportViewV1Schema, } from "../contracts/report-views.js";
import { WHAT_WE_DO_NOT_PROMISE } from "./compose-search-readiness.js";
import { clientSafeAreaLabelFromCheckId } from "./report-governance-disposition.js";
const FORBIDDEN_PHRASES = [
    "guaranteed ranking",
    "guaranteed rankings",
    "guaranteed placement",
    "guaranteed traffic",
    "guaranteed leads",
    "guaranteed revenue",
];
const FORBIDDEN_CLIENT_SAFE_KEYS = [
    "agencyId",
    "projectId",
    "runId",
    "artifactSetHash",
    "businessGraphRevisionId",
    "snapshotHash",
    "qualityGateResultId",
    "qualityGateResultRef",
    "checkId",
];
function reportTypeLabel(reportType) {
    if (reportType === "SEARCH_READINESS") {
        return "Search readiness";
    }
    return "Launch readiness";
}
export function assertNoForbiddenClientSafePhrases(text) {
    const lower = text.toLowerCase();
    for (const phrase of FORBIDDEN_PHRASES) {
        if (lower.includes(phrase)) {
            throw new Error(`client_safe_forbidden_phrase:${phrase}`);
        }
    }
}
export function assertNoClientSafeMetadataLeaks(json) {
    for (const key of FORBIDDEN_CLIENT_SAFE_KEYS) {
        if (json.includes(`"${key}"`)) {
            throw new Error(`client_safe_forbidden_field:${key}`);
        }
    }
}
export function toClientSafeReportView(report) {
    if (report.lifecycleStatus !== "READY_CLIENT_SAFE") {
        throw new Error("report_not_client_safe_ready");
    }
    const view = ClientSafeReportViewV1Schema.parse({
        schemaVersion: "client-safe-report-view.v1.0",
        publicReportRef: report.reportId,
        reportTypeLabel: reportTypeLabel(report.reportType),
        lifecycleStatus: "READY_CLIENT_SAFE",
        headline: report.headline,
        staleBanner: report.staleBanner,
        coverage: report.coverage,
        checks: report.checks.map((c) => ({
            areaLabel: clientSafeAreaLabelFromCheckId(c.checkId),
            disposition: c.disposition,
            clientSafeMessage: c.clientSafeMessage,
        })),
        whatWeDoNotPromise: [...WHAT_WE_DO_NOT_PROMISE],
        generatedAt: report.generatedAt,
        clientSafe: true,
    });
    const blob = JSON.stringify(view);
    assertNoForbiddenClientSafePhrases(blob);
    assertNoClientSafeMetadataLeaks(blob);
    return view;
}
export function toInternalReportView(report) {
    return InternalReportViewV1Schema.parse({
        schemaVersion: "internal-report-view.v1.0",
        reportId: report.reportId,
        agencyId: report.agencyId,
        projectId: report.projectId,
        reportType: report.reportType,
        lifecycleStatus: report.lifecycleStatus,
        businessGraphRevisionId: report.businessGraphRevisionId,
        artifactSetHash: report.artifactSetHash,
        qaStatus: report.qaStatus,
        headline: report.headline,
        staleBanner: report.staleBanner,
        coverage: report.coverage,
        checks: report.checks,
        generatedAt: report.generatedAt,
        clientSafe: false,
    });
}
//# sourceMappingURL=sanitize-client-safe-report.js.map